import React, { ReactElement, useState } from 'react'
import { ArtData } from '@/database/art'
import { shortenAddress, shortestAddress } from '@/utils/shortenAddress'
import { formatDateString } from '@/utils/formatting'
import { Transaction } from '@/database/transaction'
import { copyToClipboard } from '@/utils/extras'
import Image from 'next/image'

const HistoryBid = ({ artData, transaction }: { artData: ArtData; transaction: Transaction }): ReactElement => {
    const [showTooltip, setShowTooltip] = useState(false)

    const isActive =
        new Date(Date.now()) < new Date(transaction.expiration) &&
        (transaction.createdAt >= artData.art.auctions?.[0]?.auctionStart ||
            transaction.createdAt < artData.art.auctions?.[0]?.auctionEnd)

    const hash = JSON.parse(transaction.receipt).hash

    return (
        <ul>
            <span className="gray">{transaction.type}&nbsp;</span>
            <span className={isActive ? 'white' : 'light-gray'}>{transaction.amount}</span>
            <span className="gray">&nbsp;by&nbsp;</span>
            <span className={isActive ? 'white' : 'light-gray'}>{shortenAddress(transaction.sender)}&nbsp;</span>
            <span className="gray">&nbsp;at&nbsp;</span>
            <span className={isActive ? 'white' : 'light-gray'}>{formatDateString(transaction.createdAt)}&nbsp;</span>
            <span className="gray">&nbsp;hash&nbsp;</span>
            <span>
                <Image
                    src="/hexagon-copy.svg"
                    alt="arrow"
                    width={15}
                    height={15}
                    style={{
                        marginLeft: '1px',
                        cursor: 'pointer',
                    }}
                    onClick={() => copyToClipboard(hash, setShowTooltip)}
                />
                &nbsp;
                {showTooltip && (
                    <span
                        className={'gray'}
                        style={{
                            visibility: showTooltip ? 'visible' : 'hidden',
                            opacity: showTooltip ? 1 : 0,
                            transition: 'opacity 0.5s ease-in-out',
                        }}
                    >
                        Copied&nbsp;
                    </span>
                )}
                {!showTooltip && <span className={'gray'}>{shortestAddress(hash)}&nbsp;</span>}
            </span>
        </ul>
    )
}

export default HistoryBid
